var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0363932 4.43945L6.78937 8.91853L8.63705 10.1452C10.0036 11.054 11.2843 11.0619 12.6526 10.1565C15.3722 8.35731 18.0907 6.55348 20.808 4.74502C20.9471 4.65274 21.0704 4.52129 21.2918 4.48385V4.74502C21.2918 7.51227 21.2918 10.2795 21.2918 13.0468C21.2918 14.027 20.8272 14.6843 19.9987 14.9385C19.8013 14.9881 19.5975 15.0078 19.3942 14.9968C13.5689 14.9968 7.74353 14.9968 1.9182 14.9968C0.76252 14.9968 0.019771 14.2856 0.0145219 13.1425C0.000524336 10.3027 0.0145219 7.46294 0.0145219 4.62315C0.0186567 4.56159 0.0259567 4.50027 0.0363932 4.43945Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6472 0.0106826C13.5298 0.0106826 16.4133 0.035059 19.2959 0.000236218C20.7578 -0.0180457 21.4507 1.02664 21.2932 2.51618C21.2792 2.65634 21.1699 2.699 21.0754 2.76168C17.9352 4.84234 14.7937 6.92329 11.6506 9.00453C10.9901 9.43981 10.313 9.44417 9.65246 9.00453C6.50825 6.92561 3.3652 4.84524 0.223324 2.76342C0.0553526 2.65199 -0.0128882 2.53533 0.00198423 2.3412C0.0229806 2.08003 0.00198552 1.81885 0.0361047 1.56204C0.173456 0.604411 0.854093 0.0115576 1.82255 0.00981651C4.7638 0.00633424 7.70534 0.00661996 10.6472 0.0106826Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b7db09decfd21eebbe4fc78702e0a86f.svg";
export { ForwardRef as ReactComponent };